import { defaultTimeRanges } from './const';

export function getRankingListData(data, nameKey, valueKey, unit = "-") {
  return data.map((item) => {
    const { [nameKey]: transformName, [valueKey]: transformValue, ...rest } = item;

    return {
      ...rest,
      name: transformName,
      value: transformValue,
      unit,
    };
  });
}

export const getDashboardAPIUrl = ({
  auth
}) => {
  const standalone = !auth.orgs?.id || Object.keys(auth.orgs || {}).length === 0;
  const apiUrl = `${standalone ? "" : "/ents/:entId"}/orgs/:orgId/sites/:siteId/stats.read`;

  return apiUrl;
}

export const getDashboardAPIParams = ({
  auth
}) => {
  const standalone = !auth.orgs?.id || Object.keys(auth.orgs || {}).length === 0;
  const restfulParamsConfig = {
    standalone: {
      orgId: auth.realm.id,
      siteId: auth.sites.id,
    },
    nonStandalone: {
      entId: auth.realm.id,
      orgId: auth.orgs.id,
      siteId: auth.sites.id,
    },
  };

  const mode = standalone ? "standalone" : "nonStandalone";
  const restfulParams = restfulParamsConfig[mode];

  return restfulParams;
}

export const getDashboardPayload = ({
  selectedTimeRange,
  isUnityProSubscribed
}) => {
  const payload = {
    data: {
      surveillanceStatus: {},
      range: isUnityProSubscribed ? ( selectedTimeRange?.value ?? defaultTimeRanges["1d"].value ) : defaultTimeRanges["1d"].value,
    },
  };

  return payload;
}
